import request from '@/api/request'
import type { LoanOrderRow } from '@/api/types/domain'

export function fetchLoanOrdersFlat() {
  return request.get<LoanOrderRow[]>('/api/admin/loan-orders')
}

export function patchLoanOrderStatus(id: number, status: number, statusText?: string) {
  return request.patch<void>(`/api/admin/loan-orders/${id}/status`, null, {
    params: { status, ...(statusText !== undefined ? { statusText } : {}) },
  })
}
